import { render, staticRenderFns } from "./BusLines.vue?vue&type=template&id=35848dcd&scoped=true"
import script from "./BusLines.vue?vue&type=script&lang=js"
export * from "./BusLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35848dcd",
  null
  
)

export default component.exports